import { useState } from 'react';
import { Typography, Box, Button } from '@mui/material';
import CustomerFilter from './CustomerFilter';
import DataFilter from './DataFilter';
import SearchInput from '../../../components/shared/fields/SearchInput';
import CheckCircleOutlineRounded from '@mui/icons-material/CheckCircleOutlineRounded';
import { CloseRounded } from '@mui/icons-material';
import StatusFilter from './StatusFilter';
import { isNotEmptyElement } from '../../helpers/helpers';
import PaymentFilter from './PaymentFilter';

const Filters = ({ applyFilterCallback, accountId }) => {
  const baseInvoiceFilter = {
    customerIds: [],
    statuses: [],
    dueDateRangeTime: null,
    createdRangeTime: null,
    integrated: null,
    q: null,
  };
  const [invoiceFilters, setInvoiceFilters] = useState(baseInvoiceFilter);
  const [clearFilter, setClearFilter] = useState(false);
  const [filterChanged, setFilterChanged] = useState(false);
  const hasFilterData = Boolean(
    Object.keys(invoiceFilters).find((filterKey) => isNotEmptyElement(invoiceFilters[filterKey]))
  );

  const canClearFilter = filterChanged || hasFilterData;

  const handleChange = (inputName, data) => {
    const updatedData = { ...invoiceFilters };
    updatedData[inputName] = data;
    setClearFilter(false);
    setInvoiceFilters(updatedData);
    setFilterChanged(true);
  };

  const clickClearButton = () => {
    setInvoiceFilters(baseInvoiceFilter);
    applyFilterCallback(baseInvoiceFilter);
    setClearFilter(true);
    setFilterChanged(false);
  };

  const clickApplyFilter = () => {
    setClearFilter(false);
    applyFilterCallback(invoiceFilters);
    setFilterChanged(false);
  };

  return (
    <>
      <Typography variant="h7" color={'text.secondary'}> Filtros </Typography>
      <Box sx={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
        <CustomerFilter
          clearFilter={clearFilter}
          onChange={(data) => handleChange('customerIds', data)}
          accountId={accountId}
        />
        <DataFilter
          label="Data de vencimento"
          placeholder="-"
          clearFilter={clearFilter}
          onChange={(data) => handleChange('dueDateRangeTime', data)}
        />
        <DataFilter
          label="Data de emissão"
          placeholder="-"
          clearFilter={clearFilter}
          onChange={(data) => handleChange('createdRangeTime', data)}
        />
        <StatusFilter onChange={(data) => handleChange('statuses', data)} clearFilter={clearFilter} />
        <PaymentFilter onChange={(data) => handleChange('integrated', data)} clearFilter={clearFilter} />
        <SearchInput
          placeholder="Digite para pesquisar"
          variant="outlined"
          clearFilter={clearFilter}
          onChange={(data) => handleChange('q', data)}
        />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', verticalAlign: 'middle', gap: '1.5rem' }}>
        <Button
          variant="outlined"
          color="primary"
          size="medium"
          startIcon={<CheckCircleOutlineRounded />}
          disabled={!filterChanged}
          onClick={clickApplyFilter}
        >
          Aplicar filtros
        </Button>
        <Button
          variant="outlined"
          color="warning"
          size="medium"
          startIcon={<CloseRounded />}
          onClick={clickClearButton}
          disabled={!canClearFilter}
        >
          Limpar filtros
        </Button>
      </Box>
    </>
  );
};

export default Filters;
